import React, { useState } from "react"
import { useDemo } from "../context/DemoContext"
import { toast } from "react-toastify"
import { Button1 } from "./Buttons/Button1"
import PrepaidReconLogo from "../assets/logo/logo512.png"

const DemoEmailOverlay = () => {
  const { hasDemoAccess, requestDemoAccess } = useDemo()
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [phone, setPhone] = useState("")

  if (hasDemoAccess) return null

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email)
  const isValidPhone = (phone) => /^[0-9+\-\s()]{7,15}$/.test(phone)

  const submit = async () => {
    if (!email || !isValidEmail(email)) {
      toast.error("Please enter a valid email address.")
      return
    }

    if (!phone || !isValidPhone(phone)) {
      toast.error("Please enter a valid phone number.")
      return
    }

    setLoading(true)
    try {
      await requestDemoAccess(email, phone)
    } finally {
      setLoading(false)
    }
  }

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    background: "rgba(10, 10, 10, 0.65)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(20px)",
    zIndex: 7777,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.3s ease",
  }

  const modalStyle = {
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
    padding: "40px 32px",
    borderRadius: "20px",
    width: "400px",
    textAlign: "center",
    boxShadow: "0 40px 90px rgba(0,0,0,0.3)",
    animation: "fadeInScale 0.45s ease-out",
    border: "1px solid rgba(0,0,0,0.08)",
    position: "relative",
  }

  const titleStyle = {
    marginBottom: "12px",
    fontSize: "24px",
    fontWeight: 700,
    color: "#111",
  }

  const subtitleStyle = {
    fontSize: "15px",
    color: "#666",
    marginBottom: "24px",
  }

  const inputStyle = {
    width: "calc(100% - 28px)",
    padding: "14px",
    marginBottom: "20px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    fontSize: "15px",
    outline: "none",
    transition: "border 0.25s ease, box-shadow 0.25s ease",
  }

  const buttonStyle = {
    width: "100%",
    // padding: "10px",
    // background: "linear-gradient(135deg, #4A90E2, #007AFF)",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.25s ease",
  }

  return (
    <>
      {/* Animation keyframes */}
      <style>{`
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.96) translateY(12px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        input:focus {
          border-color: #4A90E2;
          box-shadow: 0 0 8px rgba(74, 144, 226, 0.35);
        }

        button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 18px rgba(74,144,226,0.35);
        }

        button:active {
          transform: translateY(0px);
          box-shadow: 0 4px 12px rgba(74,144,226,0.25);
        }

        .logo-fade-in {
            animation: logoFade 0.6s ease-out forwards;
        }

        @keyframes logoFade {
            from {
                opacity: 0;
                transform: translateY(6px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
      `}</style>

      <div style={overlayStyle}>
        <div style={modalStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: "22px",
            }}
          >
            {/* Logo */}
            <img
              src={PrepaidReconLogo}
              alt="PrepaidRecon"
              className="logo-fade-in"
              style={{
                height: 48,
                marginBottom: 10,
                filter: "drop-shadow(0 8px 18px rgba(26,43,194,0.25))",
              }}
            />

            {/* Product Name */}
            <div
              style={{
                fontSize: 20,
                fontWeight: 800,
                color: "var(--va-text-color-2)",
                letterSpacing: "0.4px",
                marginTop: 2,
              }}
            >
              Dash Recon
            </div>

            {/* Powered by */}
            <div
              style={{
                fontSize: 12,
                marginTop: 4,
                color: "var(--va-text-primary-color)",
              }}
            >
              Powered by <strong>PrepaidRecon</strong>
            </div>
          </div>

          <h2 style={titleStyle}>Get a First Look</h2>
          <p style={subtitleStyle}>Enter your email to explore the dashboard</p>

          <input type="email" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
          <input
            id="demo-phone"
            type="tel"
            placeholder="Your Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={inputStyle}
            aria-label="Phone number"
            aria-required="true"
            aria-describedby="phone-help"
          />

          <div
            id="phone-help"
            style={{
              fontSize: "12px",
              color: "#888",
              marginTop: "-12px",
              marginBottom: "16px",
              textAlign: "left",
            }}
          >
            Include country code (e.g. +1)
          </div>

          <Button1 onClick={submit} disabled={loading} style={buttonStyle}>
            {loading ? "Unlocking…" : "Continue"}
          </Button1>
        </div>
      </div>
    </>
  )
}

export default DemoEmailOverlay
